<template>
  <div>
    <div class="row">
      <div class="col-12">
        <b-table
            :items="companyBranchList"
            :fields="companyBranchListHeaders"
            hover
            responsive
            sort-icon-left
            :busy="companyBranchListLoading"
            head-row-variant="info"
            table-variant="white"
            show-empty
        >
          <template #empty="scope">
            <h6 class="text-center my-5">
              {{ scope.loading ? "Lütfen Bekleyin" : "Veri Bulunamadı"}}
            </h6>
          </template>
          <template #table-busy>
            <div class="text-center">
              <b-spinner
                  variant="primary"
                  size="lg"
                  label="Lütfen Bekleyin..."
              ></b-spinner>
            </div>
          </template>
          <template #cell(isActive)="data">
            <v-chip small label :color="data.item.isActive ? 'success ligthen-2' : 'secondary ligthen-2'">
              {{ data.item.isActive ? 'Aktif' : 'Pasif' }}
            </v-chip>
          </template>
          <template #cell(process)="data">
            <div class="text-center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      color="amber darken-2"
                      @click="openBranchDialog(data.item)"
                  >
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Düzenle</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon color="danger darken-2" @click="companyBranchDelete({
                    params:{},
                    body:{},
                    urlSegments: [data.item.id]
                  })">
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <span>Sil</span>
              </v-tooltip>
            </div>
          </template>
        </b-table>
      </div>
    </div>
    <EditBranchDialog
        :branchProp="branchProp"
        :processType="'edit'"
        :showDialog="editBranchDialog"
        @dialogChange="(data) => (editBranchDialog = data)">
    </EditBranchDialog>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import EditBranchDialog from "@/components/management/branch-management/dialogs/EditBranchDialog.vue";

export default {
  components: {EditBranchDialog},
  props: {
    perPage: {
      type: Number,
    },
    currentPage: {
      type: Number,
    }
  },

  data () {
    return {
      editBranchDialog: false,
      branchProp: null,
    }
  },
  name: "ResultsTableView.vue",
  methods: {
    ...mapActions("company", ["companyBranchDelete"]),
    openBranchDialog(data) {
      this.branchProp = data;
      this.editBranchDialog = true;
    }
  },
  computed: {
    ...mapState('company', ['companyBranchList','companyBranchListLoading','companyBranchListHeaders'])
  },
  watch: {
    "editBranchDialog": function(newVal) {
      if (!newVal) {
        this.branchProp = null;
      }
    }
  }
}
</script>

<style scoped>

</style>